export interface AddSelectOperationInterface {
  addSelect: string;
}
